var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container c-fff t-center pa-tb-20 fon-15"},[_c('div',[_vm._v(" 版权所有 上海鹿恒文化传媒 "),_c('br'),_vm._v(" 法律顾问：宗伟刚律师"),_c('br'),_c('a',{staticClass:"c-fff",attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("沪ICP备16029215号")])])])])
}]

export { render, staticRenderFns }